import { toast } from "react-toastify";
import ApiService from "../../services/apiService";
import { useRef, useEffect, useState } from "react";
import ProgressBar from "./ProgressBar";
import V1_Red from "./3D_irrigation_renders/V1_red.svg";
import V2_Red from "./3D_irrigation_renders/V2_red.svg";
import V3_Red from "./3D_irrigation_renders/V3_red.svg";
import V4_Red from "./3D_irrigation_renders/V4_red.svg";
import V5_Red from "./3D_irrigation_renders/V5_red.svg";
import V6_Red from "./3D_irrigation_renders/V6_red.svg";
import V7_Red from "./3D_irrigation_renders/V7_red.svg";
import V8_Red from "./3D_irrigation_renders/V8_red.svg";
import V9_Red from "./3D_irrigation_renders/V9_red.svg";
import V10_Red from "./3D_irrigation_renders/V10_red.svg";
import V11_Red from "./3D_irrigation_renders/V11_red.svg";
import V12_Red from "./3D_irrigation_renders/V12_red.svg";
import V13_Red from "./3D_irrigation_renders/V13_red.svg";
import V14_Red from "./3D_irrigation_renders/V14_red.svg";
import V1_Green from "./3D_irrigation_renders/V1_Green.svg";
import V2_Green from "./3D_irrigation_renders/V2_Green.svg";
import V3_Green from "./3D_irrigation_renders/V3_Green.svg";
import V4_Green from "./3D_irrigation_renders/V4_Green.svg";
import V5_Green from "./3D_irrigation_renders/V5_Green.svg";
import V6_Green from "./3D_irrigation_renders/V6_Green.svg";
import V7_Green from "./3D_irrigation_renders/V7_Green.svg";
import V8_Green from "./3D_irrigation_renders/V8_Green.svg";
import V9_Green from "./3D_irrigation_renders/V9_Green.svg";
import V10_Green from "./3D_irrigation_renders/V10_Green.svg";
import V11_Green from "./3D_irrigation_renders/V11_Green.svg";
import V12_Green from "./3D_irrigation_renders/V12_Green.svg";
import V13_Green from "./3D_irrigation_renders/V13_Green.svg";
import V14_Green from "./3D_irrigation_renders/V14_Green.svg";
import { Button } from "reactstrap";

const ValveComponent = ({
  data,
  index,
  chackData,
}: {
  data: any;
  index: any;
  chackData?: any;
}) => {
  const progressInterval = useRef<NodeJS.Timeout | null>(null);
  const [now, setNow] = useState<number>(0);
  const elapsedRef = useRef<number>(0);
  const intervalId = useRef<NodeJS.Timeout | null>(null);
  const hasStoredResponse = useRef<boolean>(false);
  const firstResponseRef = useRef<number>(0);
  const lastResponseRef = useRef<number>(0);
  const [progressBar, setProgressBar] = useState<boolean>(false);
  const [firstResponse, setFirstResponse] = useState<number>();
  const [lastResponse, setLastResponse] = useState<number>();

  let line1Index = 0;
  let line2Index = 0;

  const redImages = [
    null,
    V1_Red,
    V2_Red,
    V3_Red,
    V4_Red,
    V5_Red,
    V6_Red,
    V7_Red,
    V8_Red,
    V9_Red,
    V10_Red,
    V11_Red,
    V12_Red,
    V13_Red,
    V14_Red,
  ];

  const greenImages = [
    null,
    V1_Green,
    V2_Green,
    V3_Green,
    V4_Green,
    V5_Green,
    V6_Green,
    V7_Green,
    V8_Green,
    V9_Green,
    V10_Green,
    V11_Green,
    V12_Green,
    V13_Green,
    V14_Green,
  ];

  const valveNum = parseInt(data.valveNumber?.match(/\d+/)?.[0] || "0", 10);
  let sov = `SOV ${valveNum}`;

  const changeSov = async () => {
    try {
      const response = await ApiService.axiosApi("/qcommand", {
        method: "POST",
        data: {
          deviceid: data.chakId,
          command: data.on ? `${sov} 0` : `${sov} 1`,
          status: 0,
        },
      });
      console.log(sov);
      if (response.success) {
        startProgressBar();
        polling();

        setProgressBar(true);
      } else {
        toast.error("failure");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const startProgressBar = () => {
    // ✅ Clear existing interval to prevent overlapping
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
      progressInterval.current = null;
    }

    setNow(0); // Reset progress visually
    const stepTime = 250;
    const duration = 25000;
    const increment = 100 / (duration / stepTime);

    let current = 0;

    progressInterval.current = setInterval(() => {
      current += increment;
      if (current >= 100) {
        current = 100;
        clearInterval(progressInterval.current!);
        progressInterval.current = null; // ✅ clean up ref
      }
      setNow(current);
    }, stepTime);
  };

  const polling = () => {
    elapsedRef.current = 0;
    hasStoredResponse.current = false;
    setProgressBar(true); // Start progress bar

    // schedule repeated polling
    intervalId.current = setInterval(() => {
      callApi();
    }, 5000);
  };

  const polling2 = () => {
    elapsedRef.current = 0;
    hasStoredResponse.current = false;
    setProgressBar(true); // Start progress bar
    // schedule repeated polling
    intervalId.current = setInterval(() => {
      callRmode();
    }, 5000);
  };

  const callRmode = async () => {
    if (elapsedRef.current >= 25) return;

    elapsedRef.current += 5;
    console.log(`⏱ Elapsed: ${elapsedRef.current}s`);

    try {
      const response = await ApiService.axiosApi(`/qcommand`, {
        method: "GET",
        url: "/qcommand",
        params: {
          deviceId: data.chakId,
          command: data.romsAuto == "false" ? "RMODE 0" : "RMODE 1",
        },
      });

      if (response.success && !hasStoredResponse.current) {
        setFirstResponse(response.data.status);
        firstResponseRef.current = response.data.status;
        hasStoredResponse.current = true;
      } else {
        setLastResponse(response.data.status);
        lastResponseRef.current = response.data.status;

        // ✅ SUCCESS CASE
        if (response.data.status == 1) {
          toast.success("✅ Success");

          if (progressInterval.current) {
            clearInterval(progressInterval.current);
            progressInterval.current = null;
          }
          setNow(0);
          setProgressBar(false);

          if (intervalId.current) {
            clearInterval(intervalId.current);
          }

          return;
        }
      }
    } catch (e) {
      console.error("API error:", e);
    }

    // ❌ FAILURE CASE after 25 seconds
    if (elapsedRef.current >= 25) {
      if (intervalId.current) clearInterval(intervalId.current);
      setProgressBar(false);
      if (firstResponseRef.current === lastResponseRef.current) {
        toast.error("❌ Failure");
      }
    }
  };

  const callApi = async () => {
    // Don't increment if already timed out
    if (elapsedRef.current >= 25) return;

    elapsedRef.current += 5;

    try {
      const response = await ApiService.axiosApi(`/qcommand`, {
        method: "GET",
        url: "/qcommand",
        params: {
          deviceId: data.chakId,
          command: data.on == "true" ? `${sov} 0` : `${sov} 1`,
        },
      });

      if (response.success && !hasStoredResponse.current) {
        setFirstResponse(response.data.status);
        firstResponseRef.current = response.data.status;
        hasStoredResponse.current = true;
      } else {
        setLastResponse(response.data.status);
        lastResponseRef.current = response.data.status;

        if (response.data.status == 1) {
          toast.success("✅ Success");

          if (progressInterval.current) {
            clearInterval(progressInterval.current);
            progressInterval.current = null;
          }
          setNow(0);
          setProgressBar(false);

          if (intervalId.current) {
            clearInterval(intervalId.current);
          }

          return;
        }
      }
    } catch (e) {
      console.error("API error:", e);
    }

    // ❌ FAILURE CASE after 25 seconds
    if (elapsedRef.current >= 25) {
      if (intervalId.current) clearInterval(intervalId.current);
      setProgressBar(false);
      if (firstResponseRef.current === lastResponseRef.current) {
        toast.error("❌ Failure");
      }
    }
  };

  const isLine1 = ["V01", "V03", "V05", "V07", "V09", "V11", "V13"].includes(
    data.valveNumber
  );

  let imageElement = null;

  const imageIndex = isLine1 ? index * 1 + 1 : index * 1 + 1;
  const imgSrc = data.on
    ? greenImages[imageIndex]
    : redImages[imageIndex] || V2_Red;

  if (isLine1) {
    // 1, 3, 5, 7...

    line1Index++;

    imageElement = (
      <>
        <img
          key={data.id}
          id={`V${imageIndex}_Red`}
          src={imgSrc || V1_Red}
          alt=""
        />

        <button
          onClick={() => {
            if (!chackData.romsAuto) {
              changeSov();
            } else {
              toast.error("Please select manual mode");
            }

            console.log(data.valveNumber);
          }}
          id={`V${imageIndex}_Red`}
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50px",
            top: "10px",
            marginLeft: "5px",
            padding: "0px",
            zIndex: 10,
            backgroundColor: "transparent",
            border: "none",
            outline: "none",
            position: "absolute",
          }}
          className={data.valveNumber}
        >
          <div
            className="p-0"
            style={{
              position: "absolute",
              width: "35px",
              height: "20px",
              top: "50px",
              right: "75px",
              zIndex: 4,
            }}
          >
            {data.valveNumber}
          </div>
        </button>
      </>
    );
  } else {
    line2Index++;

    imageElement = (
      <>
        <img
          key={data.id}
          id={`V${imageIndex}_Red`}
          src={imgSrc || V1_Red}
          alt=""
        />

        <button
          onClick={() => {
            if (!chackData.romsAuto) {
              changeSov();
            } else {
              toast.error("Please select manual mode");
            }
          }}
          id={`V${imageIndex}_Red`}
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50px",
            top: "10px",
            marginLeft: "35px",
            padding: "0px",
            zIndex: 10,
            backgroundColor: "transparent",
            border: "none",
            outline: "none",
          }}
          className={data.valveNumber}
        >
          {" "}
          <div
            style={{
              paddingLeft: "60px",
              width: "40px",
              height: "40px",
              borderRadius: "50px",
              top: "10px",

              zIndex: 10,
            }}
          >
            {data.valveNumber}
          </div>{" "}
        </button>
      </>
    );
  }

  return (
    <>
      {progressBar && (
        <ProgressBar
          totalpage={0}
          pageNumber={0}
          now={now}
          mystyle={{
            position: "absolute",
            height: "25px",
            zIndex: 1000,
            backgroundColor: "whitesmoke",
            borderRadius: "4px",
            width: "1136px",
            marginLeft: "203px",
            bottom: "483px",
          }}
        />
      )}

      {imageElement}
    </>
  );
};

export default ValveComponent;
